module.exports = __webpack_public_path__ + "d691c3746c22281bd4898b2ff80cc43c.png";